module.exports = __webpack_public_path__ + "static/media/51.8e842803.jpg";